export default {"src":"/_next/static/media/female_4.4e062e40.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};